var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "table-responsive" }, [
      _c("table", [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.registros, function(registro, index) {
            return _c("tr", { key: registro.id }, [
              _c("td", { attrs: { scope: "row" } }, [
                _c("label", { attrs: { for: "check_" + registro.id } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: registro.seleccionado,
                        expression: "registro.seleccionado"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "check_" + registro.id,
                      id: "check_" + registro.id
                    },
                    domProps: {
                      checked: Array.isArray(registro.seleccionado)
                        ? _vm._i(registro.seleccionado, null) > -1
                        : registro.seleccionado
                    },
                    on: {
                      change: function($event) {
                        var $$a = registro.seleccionado,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                registro,
                                "seleccionado",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                registro,
                                "seleccionado",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(registro, "seleccionado", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(registro.prestamo.cliente.apellidos_nombres))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(registro.prestamo.cliente.numero_identificacion))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(registro.prestamo.numero_documento))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(registro.fecha_proximo_pago))])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("tfoot", [
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.registros.length < 1,
                  expression: "registros.length < 1"
                }
              ]
            },
            [_vm._m(2)]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.guardar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Guardar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cerrar } },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Créditos agendados")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cédula")]),
        _vm._v(" "),
        _c("th", [_vm._v("Crédito")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha próximo pago")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "6" } }, [
      _c("strong", [_vm._v(" No hay créditos agendados. ")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f2aa4bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f2aa4bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/CreditosAgendados.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8f2aa4bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/prestamos/cobros/CreditosAgendados.vue
// module chunks = 0